import { ORGANIZATION_API_PATHS } from '../constants/apiPaths';
import axiosOrganizationInstance from './AxiosOrganizationInstance';
import { getAuthHeaders } from './organizationStorage';
import { mapRestaurantUserRow } from '../restaurant/restaurantApi';

export const extractOrganizationId = (item) =>
  item?.organizationId ??
  item?.OrganizationId ??
  item?.organization_id ??
  item?.id ??
  null;

export const extractOrganizationName = (item) =>
  item?.organizationName ??
  item?.name ??
  item?.Name ??
  '';

export const fetchOrganizationById = async (organizationId) => {
  const response = await axiosOrganizationInstance.get(
    ORGANIZATION_API_PATHS.organizationById(organizationId),
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const updateOrganizationUser = async (userId, payload) => {
  const response = await axiosOrganizationInstance.put(
    ORGANIZATION_API_PATHS.organizationUserById(userId),
    payload,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const fetchOrganizationRootAdmin = async (organizationId) => {
  const response = await axiosOrganizationInstance.get(
    ORGANIZATION_API_PATHS.organizationRootAdminByOrganizationId(organizationId),
    { headers: getAuthHeaders() }
  );
  const owner = response.data?.owner;
  if (!owner || typeof owner !== 'object') return null;
  return mapRestaurantUserRow(owner);
};

export const updateOrganization = async (organizationId, form, updatedById) => {
  const response = await axiosOrganizationInstance.put(
    ORGANIZATION_API_PATHS.organizationById(organizationId),
    {
      organizationName: form.organizationName,
      organizationCode: form.organizationCode,
      organizationType: form.organizationType,
      phoneNumber: form.phoneNumber,
      email: form.email,
      website: form.website,
      admissions: form.admissions,
      specialization: form.specialization,
      offers: form.offers,
      notes: form.notes,
      status: form.status,
      updatedById: updatedById ?? 1,
    },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const deleteOrganization = async (organizationId) => {
  const response = await axiosOrganizationInstance.delete(
    ORGANIZATION_API_PATHS.organizationById(organizationId),
    { headers: getAuthHeaders() }
  );
  return response.data;
};
